export default __webpack_public_path__ + "static/media/fr1.e5806c67.jpg";